module.exports = __webpack_public_path__ + "static/logo-mobile-d864545e899ceeddca452dc4460c6867.png";